"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: billing/testing/billing-testing-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fbilling%2Ftesting%2Fbilling-testing-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetNextAutoPayAtResponse = exports.SetNextAutoPayAtRequest = exports.GetUnbilledTransactionsResponse = exports.GetUnbilledTransactionsRequest = exports.SetTransactionTimeResponse = exports.SetTransactionTimeRequest = exports.ProcessBillResponse = exports.ProcessBillRequest = exports.SetBillDueAtResponse = exports.SetBillDueAtRequest = exports.IsUpToDateResponse = exports.IsUpToDateRequest = exports.GenerateBillResponse = exports.GenerateBillRequest = exports.UnbilledTransaction = void 0;
const amount_1 = require("../../common/amount");
const protobufPackage = 'com.step.billing.proto';
function createBaseUnbilledTransaction() {
    return {
        accountId: '',
        transactionId: '',
        amount: amount_1.Amount.fromPartial({}),
        committedAt: '0',
        title: '',
    };
}
exports.UnbilledTransaction = {
    fromJSON(object) {
        const message = {
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
            transactionId: isSet(object.transactionId) ? globalThis.String(object.transactionId) : '',
            amount: isSet(object.amount) ? amount_1.Amount.fromJSON(object.amount) : amount_1.Amount.fromPartial({}),
            committedAt: isSet(object.committedAt) ? globalThis.String(object.committedAt) : '0',
            title: isSet(object.title) ? globalThis.String(object.title) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        if (message.transactionId !== '') {
            obj.transactionId = message.transactionId;
        }
        if (message.amount !== undefined) {
            obj.amount = amount_1.Amount.toJSON(message.amount);
        }
        if (message.committedAt !== '0') {
            obj.committedAt = message.committedAt;
        }
        if (message.title !== '') {
            obj.title = message.title;
        }
        return obj;
    },
    create(base) {
        return exports.UnbilledTransaction.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUnbilledTransaction();
        message.accountId = object.accountId ?? '';
        message.transactionId = object.transactionId ?? '';
        message.amount = (object.amount !== undefined && object.amount !== null)
            ? amount_1.Amount.fromPartial(object.amount)
            : amount_1.Amount.fromPartial({});
        message.committedAt = object.committedAt ?? '0';
        message.title = object.title ?? '';
        return message;
    },
};
function createBaseGenerateBillRequest() {
    return { primaryAccountId: '', billingCutoffMs: '0' };
}
exports.GenerateBillRequest = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
        };
        if (isSet(object.billingCutoffMs)) {
            message.billingCutoffMs = globalThis.String(object.billingCutoffMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.billingCutoffMs !== undefined && message.billingCutoffMs !== '0') {
            obj.billingCutoffMs = message.billingCutoffMs;
        }
        return obj;
    },
    create(base) {
        return exports.GenerateBillRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGenerateBillRequest();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.billingCutoffMs = object.billingCutoffMs ?? '0';
        return message;
    },
};
function createBaseGenerateBillResponse() {
    return {};
}
exports.GenerateBillResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GenerateBillResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGenerateBillResponse();
        return message;
    },
};
function createBaseIsUpToDateRequest() {
    return { primaryAccountId: '', billingCutoffMs: '0' };
}
exports.IsUpToDateRequest = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
        };
        if (isSet(object.billingCutoffMs)) {
            message.billingCutoffMs = globalThis.String(object.billingCutoffMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.billingCutoffMs !== undefined && message.billingCutoffMs !== '0') {
            obj.billingCutoffMs = message.billingCutoffMs;
        }
        return obj;
    },
    create(base) {
        return exports.IsUpToDateRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseIsUpToDateRequest();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.billingCutoffMs = object.billingCutoffMs ?? '0';
        return message;
    },
};
function createBaseIsUpToDateResponse() {
    return { isUpToDate: false };
}
exports.IsUpToDateResponse = {
    fromJSON(object) {
        const message = {
            isUpToDate: isSet(object.isUpToDate) ? globalThis.Boolean(object.isUpToDate) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.isUpToDate !== false) {
            obj.isUpToDate = message.isUpToDate;
        }
        return obj;
    },
    create(base) {
        return exports.IsUpToDateResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseIsUpToDateResponse();
        message.isUpToDate = object.isUpToDate ?? false;
        return message;
    },
};
function createBaseSetBillDueAtRequest() {
    return { billId: '', dueAtMs: '0' };
}
exports.SetBillDueAtRequest = {
    fromJSON(object) {
        const message = {
            billId: isSet(object.billId) ? globalThis.String(object.billId) : '',
            dueAtMs: isSet(object.dueAtMs) ? globalThis.String(object.dueAtMs) : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.billId !== '') {
            obj.billId = message.billId;
        }
        if (message.dueAtMs !== '0') {
            obj.dueAtMs = message.dueAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.SetBillDueAtRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetBillDueAtRequest();
        message.billId = object.billId ?? '';
        message.dueAtMs = object.dueAtMs ?? '0';
        return message;
    },
};
function createBaseSetBillDueAtResponse() {
    return {};
}
exports.SetBillDueAtResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SetBillDueAtResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSetBillDueAtResponse();
        return message;
    },
};
function createBaseProcessBillRequest() {
    return { billId: '' };
}
exports.ProcessBillRequest = {
    fromJSON(object) {
        const message = {
            billId: isSet(object.billId) ? globalThis.String(object.billId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.billId !== '') {
            obj.billId = message.billId;
        }
        return obj;
    },
    create(base) {
        return exports.ProcessBillRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseProcessBillRequest();
        message.billId = object.billId ?? '';
        return message;
    },
};
function createBaseProcessBillResponse() {
    return {};
}
exports.ProcessBillResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.ProcessBillResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseProcessBillResponse();
        return message;
    },
};
function createBaseSetTransactionTimeRequest() {
    return { accountId: '', transactionId: '', timeMs: '0' };
}
exports.SetTransactionTimeRequest = {
    fromJSON(object) {
        const message = {
            accountId: isSet(object.accountId) ? globalThis.String(object.accountId) : '',
            transactionId: isSet(object.transactionId) ? globalThis.String(object.transactionId) : '',
            timeMs: isSet(object.timeMs) ? globalThis.String(object.timeMs) : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountId !== '') {
            obj.accountId = message.accountId;
        }
        if (message.transactionId !== '') {
            obj.transactionId = message.transactionId;
        }
        if (message.timeMs !== '0') {
            obj.timeMs = message.timeMs;
        }
        return obj;
    },
    create(base) {
        return exports.SetTransactionTimeRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetTransactionTimeRequest();
        message.accountId = object.accountId ?? '';
        message.transactionId = object.transactionId ?? '';
        message.timeMs = object.timeMs ?? '0';
        return message;
    },
};
function createBaseSetTransactionTimeResponse() {
    return {};
}
exports.SetTransactionTimeResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SetTransactionTimeResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSetTransactionTimeResponse();
        return message;
    },
};
function createBaseGetUnbilledTransactionsRequest() {
    return { accountIds: [] };
}
exports.GetUnbilledTransactionsRequest = {
    fromJSON(object) {
        const message = {
            accountIds: globalThis.Array.isArray(object?.accountIds)
                ? object.accountIds.map((e) => globalThis.String(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.accountIds?.length) {
            obj.accountIds = message.accountIds;
        }
        return obj;
    },
    create(base) {
        return exports.GetUnbilledTransactionsRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetUnbilledTransactionsRequest();
        message.accountIds = object.accountIds?.map((e) => e) || [];
        return message;
    },
};
function createBaseGetUnbilledTransactionsResponse() {
    return { transactions: [] };
}
exports.GetUnbilledTransactionsResponse = {
    fromJSON(object) {
        const message = {
            transactions: globalThis.Array.isArray(object?.transactions)
                ? object.transactions.map((e) => exports.UnbilledTransaction.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.transactions?.length) {
            obj.transactions = message.transactions.map((e) => exports.UnbilledTransaction.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetUnbilledTransactionsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetUnbilledTransactionsResponse();
        message.transactions = object.transactions?.map((e) => exports.UnbilledTransaction.fromPartial(e)) ||
            [];
        return message;
    },
};
function createBaseSetNextAutoPayAtRequest() {
    return { primaryAccountId: '', payAtMs: '0' };
}
exports.SetNextAutoPayAtRequest = {
    fromJSON(object) {
        const message = {
            primaryAccountId: isSet(object.primaryAccountId)
                ? globalThis.String(object.primaryAccountId)
                : '',
            payAtMs: isSet(object.payAtMs) ? globalThis.String(object.payAtMs) : '0',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.primaryAccountId !== '') {
            obj.primaryAccountId = message.primaryAccountId;
        }
        if (message.payAtMs !== '0') {
            obj.payAtMs = message.payAtMs;
        }
        return obj;
    },
    create(base) {
        return exports.SetNextAutoPayAtRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetNextAutoPayAtRequest();
        message.primaryAccountId = object.primaryAccountId ?? '';
        message.payAtMs = object.payAtMs ?? '0';
        return message;
    },
};
function createBaseSetNextAutoPayAtResponse() {
    return {};
}
exports.SetNextAutoPayAtResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.SetNextAutoPayAtResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseSetNextAutoPayAtResponse();
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=billing-testing-service.js.map